import { render } from "./SamplesComponent.vue?vue&type=template&id=065a916c"
import script from "./SamplesComponent.vue?vue&type=script&lang=js"
export * from "./SamplesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__